import { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';
import QuoteCardContent from './QuoteCardContent';
import ButtonLink from '../shared/ButtonLinkComponent';
import { device } from '../../utils/styled-component-mixins';
import ImgWrapper from '../shared/ImgWrapper';

const QuoteCardStyled = styled.article`
  align-items: flex-end;
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  position: relative;

  &::before {
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
    box-shadow: var(--card-shadow);
  }

  .btn-wrapper,
  .btn-wrapper {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    @media ${device.deviceOnly} {
      width: 100% !important;
    }

    a {
      width: 100%;
    }
  }

  .btn-wrapper {
    margin-top: 4rem;
  }

  .testimonial-content-wrapper {
    padding: 4rem 1.6rem;
    width: 100%;

    @media ${device.desktop} {
      padding: 4rem;
    }
  }
`;

const QuoteCard = (props) => {
  const { properties, testimonial } = props;
  const quoteCardRef = useRef(null);
  const [isFirstRender, setIsFirstRender] = useState(true);

  const setButtonWidth = () => {
    const cardWidth = quoteCardRef?.current?.offsetWidth;
    const cardWidthButtonBreakpoint = 640;
    const btnWrapper = quoteCardRef?.current?.querySelector('.btn-wrapper > *');

    if (cardWidth > cardWidthButtonBreakpoint) {
      if (btnWrapper) {
        btnWrapper.style.width = `auto`;
      }
    } else if (btnWrapper) {
      btnWrapper.style.width = `100%`;
    }
  };

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false);
    } else {
      setButtonWidth();
    }

    window.addEventListener('resize', setButtonWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFirstRender]);

  return (
    <>
      <WidgetIdWrapper widgetID={properties.widgetID}>
        <QuoteCardStyled ref={quoteCardRef}>
          {properties.image && (
            <ImgWrapper
              imageSrc={properties.image}
              imageAlt={properties.imageAltText}
              aspectRatio="56.25"
            />
          )}
          <div className="testimonial-content-wrapper">
            {testimonial ? (
              <QuoteCardContent
                heading={properties.heading}
                subheading={properties.subheading}
                quote={testimonial.quote}
                author={testimonial.author}
                authorTitle={testimonial.authorTitle}
                quoteHasLargeText={properties.largeQuoteText}
              />
            ) : (
              <QuoteCardContent heading={properties.heading} subheading={properties.subheading} />
            )}
            {properties.buttonText && properties.buttonUrl && (
              <ButtonLink
                text={properties.buttonText}
                link={properties.buttonUrl}
                type="primary"
                theme="light"
                isExternal={properties.isExternal}
              />
            )}
          </div>
        </QuoteCardStyled>
      </WidgetIdWrapper>
    </>
  );
};

export default withWidgetSpacingWrapper(QuoteCard);
